export class RegistrationForm {

    constructor(
        public name: string,
        public surname: string,
        public familySurname: string,
        public phoneNumber: string,
        public pesel: string,
        public motherName: string,
        public motherSurname: string,
        public fatherName: string,
        public street: string,
        public buildingNumber: string,
        public flatNumber: string,
        public postCode: string,
        public city: string,
        public rodoAccept: string,
    ) { }
}